import React from "react";
import { useNavigate } from "react-router-dom";
export default function EmailVerifiedModal() {
  const navi = useNavigate();

  const handleClick = () => {
    navi("/");
  };
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Email Verifed</p>
        </div>

        <p>
          Congratulations, your email address has been successfully verified.
          Welcome to Membotic!
        </p>
        <p>
          You can now enjoy all the features and benefits of our application. If
          you have any questions or need assistance, feel free to reach out to
          our support team.
        </p>
        <p>Thank you for joining us!</p>

        <div className="send-modal-footer">
          <button
            className="pointer cancelButton fw-bold mx-2 px-3"
            onClick={handleClick}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
